<template>
  <div class="container text-center col-lg-8">
    <div v-if="errorPage">
      <br />
      <div class="alert alert-danger text-center">Ο επερχόμενος διαγωνισμός δεν βρέθηκε!</div>
    </div>
    <div v-if="errorCreatingBidder">
      <br />
      <div class="alert alert-danger text-center">Παρουσιάστηκε σφάλμα κατά την υποβολή της αίτησής σας. Προσπαθήστε ξανά.</div>
    </div>
    <div v-else>
      <div v-if="!submitted">
        <b-card
          header="Φόρμα εκδήλωσης ενδιαφέροντος:"
          border-variant="dark"
          header-border-variant="info"
          header-text-variant="info"
          header-class="h4"
        >
          <b-form v-if="!submitted" class="col-md-8 mx-auto font-weight-bold">
            <b-form-group label-for="onoma">
              <template v-slot:label>
                <span>'Ονομα</span>&nbsp;<sup>*</sup>
              </template>
              <b-form-input
                id="onoma"
                type="text"
                class="form-control"
                required
                v-model="bidder.onoma"
                name="onoma"
              />
            </b-form-group>

            <b-form-group label-for="epwnymo">
              <template v-slot:label>
                <span>Επώνυμο</span>&nbsp;<sup>*</sup>
              </template>
              <b-form-input
                id="epwnymo"
                type="text"
                class="form-control"
                required
                v-model="bidder.epwnymo"
                name="epwnymo"
              />
            </b-form-group>
            <b-form-group label="Φυσικό Πρόσωπο-Εταιρία:" label-for="etairKoinop">
              <b-form-input
                id="etairKoinop"
                type="text"
                class="form-control"
                required
                v-model="bidder.etairKoinop"
                name="etairKoinop"
              />
            </b-form-group>
          <b-form-group class="mb-1" label-for="adt">
            <template v-slot:label>
              <span>ΑΔΤ</span>&nbsp;<sup>*</sup>
            </template>
            <b-form-input
              type="text"
              class="form-control"
              id="adt"
              required
              v-model="bidder.adt"
              placeholder="πχ. ΑΑ123456 (ελληνικοί χαρακτήρες)"
              name="adt"
            />
          </b-form-group>
            <b-form-group label-for="afm">
              <template v-slot:label>
                <span>ΑΦΜ</span>&nbsp;<sup>*</sup>
              </template>
              <b-form-input
                id="afm"
                type="text"
                class="form-control"
                required
                v-model="bidder.afm"
                placeholder="πχ. 012345678"
                name="afm"
              />
            </b-form-group>

            <b-form-group label-for="address">
              <template v-slot:label>
                <span>Διεύθυνση</span>&nbsp;<sup>*</sup>
              </template>
              <b-form-input
                id="address"
                type="text"
                class="form-control"
                required
                placeholder="πχ. εθνικής αντιστάσεως 30 (ελληνικοί χαρακτήρες)"
                v-model="bidder.address"
                name="address"
              />
            </b-form-group>

            <b-form-group label-for="mail">
              <template v-slot:label>
                <span>e-mail</span>&nbsp;<sup>*</sup>
              </template>
              <b-form-input
                id="mail"
                type="text"
                class="form-control"
                required
                placeholder="πχ. papadakis@gmail.com"
                v-model="bidder.mail"
                name="mail"
              />
            </b-form-group>

            <b-form-group label-for="thl">
              <template v-slot:label>
                <span>Τηλέφωνο</span>&nbsp;επικοινωνίας&nbsp;<sup>*</sup>
              </template>
              <b-form-input
                id="thl"
                type="text"
                class="form-control"
                required
                placeholder="πχ. 6999999999"
                v-model="bidder.thl"
                name="thl"
              />
            </b-form-group>
          </b-form>
          <label>
            <b>Επιλέξτε Υλικά:</b>&nbsp;<sup>*</sup>
          </label>
          <MaterialsTable
            :fields="ylikaFields"
            :items="ylika"
            :checkFlag='true'
            :nested='false'
            :idPrefix="''"
            @checkEvent="addMaterial"
          />
          <div v-if="ypsosEgguhtikis">
            <label>
              <b>'Υψος Εγγυητικής επιστολής:</b>
              <Currency :price="ypsosEgguhtikis"></Currency>
            </label>
          </div>
          <div class="text-left">
            <sup>*</sup>&nbsp;<span>Υποχρεωτικά πεδία</span>
          </div>
        </b-card>
        <div v-if="showCaptcha">
          <br />
          <reCAPTCHA ref="googleReCaptcha" v-bind:data-sitekey="this.GOOGLE_RECAPTCHA_SITE_KEY" style="display: inline-block;  margin: auto;"></reCAPTCHA>
          <div id="g-recaptcha-error"></div>
          <br />
        </div>
        <b-button class="m-2" variant="success" @click="saveBidder()">Υποβολή</b-button>
      </div>
      <div v-else>
        <div
          class="alert alert-success"
        >Ευχαριστούμε για το ενδιαφέρον σας! Θα σας αποσταλεί ενημερωτικό μήνυμα στην ηλεκτρονική διεύθυνση που καταχωρήσατε.</div>
      </div>
    </div>
  </div>
</template>

<script>
import BidderService from '../services/bidder.service.js';
import MaterialsTable from '../components/MaterialsTable.vue';
import ReCAPTCHA from "../components/reCAPTCHA";
import Currency from "../components/Currency";

export default {
  name: 'interest-form',
  components: {
    MaterialsTable,
    ReCAPTCHA,
    Currency
  },
  data() {
    return {
      errorPage: false,
      errorCreatingBidder: false,
      showCaptcha: false,
      dimopId: null,
      selected: [],
      ylika: [],
      percentage: null,
      ypsosEgguhtikis: null,
      bidder: {
        id: null,
        onoma: '',
        epwnymo: '',
        etairKoinop: '',
        adt: '',
        afm: '',
        address: '',
        mail: '',
        thl: ''
      },
      submitted: false,
      ylikaFields: [
        {
          key:'id-column',
          label:'Κωδικός Υλικού'
        },
        {
          key: 'yliko.perigrafh',
          label: 'Περιγραφή'
        },
        {
          key: 'yliko.posothta',
          label: 'Ποσότητα'
        },
        {
          key: 'timiEkkinisisDimoprasias',
          label: 'Τιμή εκκίνισης'
        },
        {
          key: 'yliko.id',
          label: ''
        },
        {
          key: 'yliko.id',
          label: ''
        }
      ]
    };
  },
  methods: {
    getInterestForm(id) {
      BidderService.getInterestForm(id)
        .then(response => {
          this.ylika = response.data.ylika;
          this.percentage = response.data.egguhtikhPercentage;
          //console.log(response.data);
        })
        .catch(e => {
          this.errorPage = true;
          console.log(e);
        });
    },
    saveBidder() {
      let reCAPTCHAUserToken = null;
      if (this.showCaptcha) {
        // eslint-disable-next-line no-undef
        reCAPTCHAUserToken = this.$refs.googleReCaptcha.getUserToken();

        if (reCAPTCHAUserToken.length == 0) {
          document.getElementById('g-recaptcha-error').innerHTML = '<span style="color:red;">Η επίλυση του captcha είναι απαραίτητη.</span>';
          return;
        }
      }

      var data = {
        dimopId: this.dimopId,
        onoma: this.bidder.onoma,
        epwnymo: this.bidder.epwnymo,
        etairKoinop: this.bidder.etairKoinop,
        adt: this.bidder.adt,
        afm: this.bidder.afm,
        address: this.bidder.address,
        mail: this.bidder.mail,
        thl: this.bidder.thl,
        materialIds: this.selected,
        reCAPTCHAUserToken: reCAPTCHAUserToken
      };
      BidderService.createBidder(this.dimopId, data)
        .then(response => {
          this.bidder.id = response.data.id;
          //console.log(response.data);
          this.submitted = true;
          //this.$router.push('/home');
        })
        .catch(e => {
          if (this.showCaptcha) {
            this.$refs.googleReCaptcha.reset();
          }
          this.errorCreatingBidder = true;
        });
    },
    setDimopId(id) {
      this.dimopId = id;
    },
    newAuction() {
      this.submitted = false;
      this.auction = {};
    },
    addMaterial(matId) {
      if (!this.selected.includes(matId)) {
        this.selected.push(matId);
      } else {
        this.selected = this.selected.filter(e => e !== matId);
      }

      var sum = 0;
      this.ypsosEgguhtikis = 0;
      for (var i = 0; i < this.selected.length; i++) {
        for (var j = 0; j < this.ylika.length; j++) {
          if (this.ylika[j].yliko.id == this.selected[i]) {
            sum += this.ylika[j].timiEkkinisisDimoprasias;
          }
        }
      }
      this.ypsosEgguhtikis = (sum * this.percentage) / 100;
    },
  },
  mounted() {
    this.getInterestForm(this.$route.params.id);
    this.setDimopId(this.$route.params.id);

    this.GOOGLE_RECAPTCHA_SITE_KEY = process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY;
    this.showCaptcha = process.env.NODE_ENV !== 'development';
  }
};
</script>